import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
const isV3 = allVue.version && allVue.version[0] === '3'
import KendoArcGaugeMixin from './KendoArcGaugeMixin'

export default {
    name: 'kendo-arcgauge',
    mixins: [ KendoArcGaugeMixin ],
    setup() {
        const v3 = isV3
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('div', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoArcGauge/index.js